// Props untuk QuestionReportBox (hanya sebagai referensi, tidak ada interface di JS)
export const QuestionReportBoxDefaultProps = {
  isOpen: false,
  handleClose: () => { },
  id: null,
};

// Kategori laporan
export const ReportCategory = {
  Question: "question",
  Submateri: "sub_material",
};

// Enum tipe laporan soal
export const QuestionReportType = {
  Question: "question",
  AnswerKey: "answer_key",
  Explanation: "explanation",
  NoAnswer: "no_answer",
  Inquiry: "inquiry",
  Others: "others",
};

// Enum tipe laporan submateri
export const SubmateriReportType = {
  Question: "question",
  Comment: "comment",
  Trouble: "trouble",
};

// Opsi laporan soal
export const questionReportOptions = {
  [QuestionReportType.Question]: "Laporkan Soal",
  [QuestionReportType.AnswerKey]: "Laporkan Kunci Jawaban",
  [QuestionReportType.Explanation]: "Laporkan Pembahasan",
  [QuestionReportType.NoAnswer]: "Laporkan Pilihan Jawaban",
  [QuestionReportType.Inquiry]: "Pertanyaan terkait soal",
  [QuestionReportType.Others]: "Lainnya...",
};

// Opsi laporan submateri
export const submateriReportOptions = {
  [SubmateriReportType.Question]: "Laporkan Sub Materi",
  [SubmateriReportType.Comment]: "Komentar Sub Materi",
  [SubmateriReportType.Trouble]: "Masalah pada Sub Materi",
};

// Opsi kategori hasil audit AI (konteks: AI yang menemukan masalah, bukan user).
// Key sama dengan questionReportOptions + SubmateriReportType.Trouble.
export const aiAuditCategoryOptions = {
  [QuestionReportType.Question]: "Masalah pada Soal",
  [QuestionReportType.AnswerKey]: "Kunci Jawaban Salah",
  [QuestionReportType.Explanation]: "Pembahasan Bermasalah",
  [QuestionReportType.NoAnswer]: "Pilihan Jawaban Bermasalah",
  [QuestionReportType.Inquiry]: "Pertanyaan terkait Soal",
  [QuestionReportType.Others]: "Lainnya",
  [SubmateriReportType.Trouble]: "Masalah Teknis",
};

// Mapping untuk tipe ticketable (menampilkan format yang lebih rapi)
export const ticketableTypeOptions = {
  question: "Question",
  sub_material: "Sub Materi",
};

// Helper function untuk capitalize first letter
export const capitalizeFirstLetter = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// Label prompt soal
export const questionReportLabelPrompts = {
  [QuestionReportType.Question]: "Menurut Anda, apa yang perlu di perbaiki?",
  [QuestionReportType.AnswerKey]: "Apa jawaban yang benar dan mengapa?",
  [QuestionReportType.Explanation]: "Bagian mana dari pembahasan yang perlu di perbaiki dan bagaimana seharusnya?",
  [QuestionReportType.NoAnswer]: "Jika memungkinkan, tuliskan jawaban yang menurut Anda benar.",
  [QuestionReportType.Inquiry]: "Apa yang ingin Anda tanyakan mengenai soal ini?",
  [QuestionReportType.Others]: "Mohon sebutkan dan jelaskan masalah yang Anda temukan.",
};

// Label prompt submateri
export const submateriReportLabelPrompts = {
  [SubmateriReportType.Question]: "Apa yang perlu diperbaiki dari submateri ini?",
  [SubmateriReportType.Comment]: "Silakan tuliskan komentar Anda tentang submateri ini.",
  [SubmateriReportType.Trouble]: "Jelaskan masalah yang Anda temukan pada submateri.",
};

export const MAX_CHARS = 255;